'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var classNames = require('classnames');
var GridWithSpacing = require('../../../common/GridWithSpacing.js');
var Grid = require('../../Layout/Grid/Grid.js');
var Button = require('./Button/Button.js');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var Add = require('../../../node_modules/@material-ui/icons/Add.js');
var makeStyles = require('../../Styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    inheritFontColor: {
      color: 'inherit'
    },
    flex: {
      display: 'flex'
    },
    button: {
      borderRadius: 8,
      border: '1px solid #D8D8D8',
      padding: '10px 16px'
    },
    buttonRoot: function buttonRoot(_ref) {
      var backgroundColor = _ref.backgroundColor,
          noHover = _ref.noHover,
          noBorder = _ref.noBorder,
          verticalMargin = _ref.verticalMargin;
      var style = {
        textTransform: 'none',
        fontSize: 16,
        color: theme.palette.secondary.light,
        '&:hover': {
          color: theme.palette.black.primary
        }
      };

      if (verticalMargin) {
        style['marginTop'] = 8 * verticalMargin;
        style['marginBottom'] = 8 * verticalMargin;
      }

      if (noHover) {
        style['&:hover'] = {
          backgroundColor: backgroundColor
        };
        style['color'] = theme.palette.black.primary;
      }

      if (noBorder) {
        style['&:hover'].border = 'none';
        style['border'] = 'none';
      }

      if (backgroundColor) {
        style['backgroundColor'] = backgroundColor;
      }

      return style;
    },
    textContainer: {
      marginLeft: 18
    },
    actionText: {
      marginRight: 27
    }
  };
});

var StructuredCardButton = function StructuredCardButton(_ref2) {
  var title = _ref2.title,
      subTitle = _ref2.subTitle,
      icon = _ref2.icon,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      actionIcon = _ref2.actionIcon,
      actionIconText = _ref2.actionIconText,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$classes = _ref2.classes,
      classes = _ref2$classes === void 0 ? {} : _ref2$classes,
      className = _ref2.className;
  var titleVariant = subTitle ? "subtitle1" : "body1";

  var _useStyles$classes = _objectSpread({}, useStyles(), {}, classes),
      button = _useStyles$classes.button,
      buttonRoot = _useStyles$classes.buttonRoot,
      flex = _useStyles$classes.flex,
      iconItem = _useStyles$classes.iconItem,
      inheritFontColor = _useStyles$classes.inheritFontColor,
      textContainer = _useStyles$classes.textContainer,
      actionText = _useStyles$classes.actionText;

  return React__default["default"].createElement(Button["default"], {
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    disabled: disabled,
    onClick: onClick,
    className: classNames__default["default"](button, className),
    classes: {
      root: buttonRoot
    }
  }, React__default["default"].createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "space-between",
    wrap: "nowrap"
  }, React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(GridWithSpacing, {
    alignItems: "center",
    spacing: 8
  }, icon && React__default["default"].createElement(Grid, {
    item: true,
    className: flex
  }, icon), React__default["default"].createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    xs: true,
    className: textContainer
  }, React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    className: inheritFontColor,
    align: "left",
    variant: titleVariant
  }, title)), subTitle && React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    className: inheritFontColor,
    align: "left",
    variant: "body2"
  }, subTitle))))), React__default["default"].createElement(Grid, {
    item: true,
    className: classNames__default["default"](flex, iconItem)
  }, actionIconText && React__default["default"].createElement(Typography, {
    className: classNames__default["default"](inheritFontColor, actionText),
    variant: "body2"
  }, actionIconText), actionIcon ? React__default["default"].cloneElement(actionIcon, {
    color: 'inherit'
  }) : React__default["default"].createElement(Add, {
    color: "primary"
  }))));
};

module.exports = StructuredCardButton;
